module.exports = __webpack_public_path__ + "static/standardsite-fd798e6af853a669d4f72d0910b3c4f8.png";